// extracted by mini-css-extract-plugin
export var container = "mainButton-module--container--uFJdp";
export var bold = "mainButton-module--bold--XM-lK";
export var mainText = "mainButton-module--mainText--+rx9u";
export var ethhButton = "mainButton-module--ethhButton--rcXYW";